/**
 * Creates a coupon form component with toggle functionality
 * @param {HTMLElement|jQuery} element - The coupon form element
 * @returns {Object} - The coupon form component API
 */
export function createCheckoutCouponForm(element) {
  function getElements() {
    return {
      $form: jQuery(".woocommerce-form-coupon"),
      $noticeContainer: jQuery(
        ".woocommerce-form-coupon .js-coupon-notice-container"
      ),
    };
  }

  /**
   * Toggle the visibility of the coupon form
   * Get fresh references each time to avoid stale jQuery objects
   */
  function toggle() {
    const { $form } = getElements();

    // Determine current visibility (don't rely on cached state)
    const isCurrentlyVisible = $form.is(":visible");

    if (isCurrentlyVisible) {
      // Hide the form
      $form.slideUp(200, function () {
        $form.addClass("hidden").css("display", "");
      });
    } else {
      // Show the form
      $form.removeClass("hidden").slideDown(200, function () {
        $form.find('input[name="coupon_code"]').focus();
      });
    }
  }

  /**
   * Move any WooCommerce error notices into our dedicated container
   */
  function moveErrorNotices() {
    const { $form, $noticeContainer } = getElements();

    // Check if there's any error notice directly inside the flex container
    const $flexContainer = $form.find(".flex");
    const $errorNotice = $flexContainer.find(".coupon-error-notice");

    if ($errorNotice.length) {
      // Move it to our dedicated container
      $noticeContainer.html($errorNotice);
      $errorNotice.addClass("block");
    }
  }

  /**
   * Enhance WooCommerce message styling
   */
  function enhanceWooMessages() {
    // Make sure error lists are properly formatted
    jQuery(".woocommerce-error").each(function () {
      const $errorList = jQuery(this);
      if (!$errorList.find("li").length) {
        // If it's not already a list, convert it to one
        const errorMessage = $errorList.html();
        $errorList.html(`<li>${errorMessage}</li>`);
      }
    });
  }

  /**
   * Initialize the component
   */
  function init() {
    // Clean up any previous event handlers first
    jQuery(document).off("click.couponToggle");

    // Set up the event handler using direct delegation
    jQuery(document).on(
      "click.couponToggle",
      ".js-toggle-coupon-form",
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Always toggle based on current DOM state, not cached state
        toggle();

        return false;
      }
    );

    // Set up observer for error notices and WooCommerce messages
    if (window.MutationObserver) {
      const observer = new MutationObserver(function () {
        moveErrorNotices();
        enhanceWooMessages();
      });

      // Observe the checkout form
      const checkoutForm = document.querySelector("form.checkout");
      if (checkoutForm) {
        observer.observe(checkoutForm, {
          childList: true,
          subtree: true,
        });
      }

      // Observe notices
      const noticesWrapper = document.querySelector(
        ".woocommerce-notices-wrapper"
      );
      if (noticesWrapper) {
        observer.observe(noticesWrapper, {
          childList: true,
          subtree: true,
        });
      }
    }

    // Initialize
    moveErrorNotices();
    enhanceWooMessages();
  }

  // Initialize once
  init();

  return {
    toggle,
  };
}
